import { useMemo, FC, useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid } from "@mui/material";
import { raiseRouteOverwatchOrgProfile } from "@/actions/routeOverwatch";
import { Content } from "@/components/content/Content";
import Create from "@/controller/Create";
import { OdResourcePageProps } from "@/types/resource";
import { useResourceRegister } from "@/utils/resourceRegister";
import { MfaWay, UserResponseDto } from "@/gen/api/user";
import { MutationCallbacks } from "@/dataProvider/types";
import { ProfileCreateForm } from "@/components/profile/ProfileCreateForm";
import ProfileAvatar from "@/components/profile/ProfileAvatar";
import { getUserProfile } from "@/reducers/userProfile";
import { useSimpleSaveAction } from "@/controller/SaveContextProvider";
import { crudGetOneEx } from "@/actions/crudFetchEx";
import { useIsSecureFileOnly } from "@/authProvider/useIsSecureFileOnly";
import { useIsLocalUserWithNoPhone } from "@/authProvider/useIsLocalUserWithNoPhone";



const ProfileCreate: FC<OdResourcePageProps> = (props) => {
  useResourceRegister({ name: 'timezone-options' })

  const dispatch = useDispatch()
  const handlers = useMemo(() => {
    return {
      onSuccess: () => {
        dispatch(crudGetOneEx('profile', 'edit', ''))
        dispatch(raiseRouteOverwatchOrgProfile())
      }
    }
  }, [dispatch])
  const isSecureFileOnly = useIsSecureFileOnly()
  const isLocalUserWithNoPhone = useIsLocalUserWithNoPhone()

  return (
    <Create resource={props.resource} basePath="" {...handlers} >
      <Content pageName={"User Profile Create"} resourceName="Profile" breadcrumbs={(isSecureFileOnly || isLocalUserWithNoPhone) ? undefined : props.options?.breadcrumbs}>
        <ProfileCreateBody />
      </Content>
    </Create>
  )
}

export default ProfileCreate;

export interface ProfileFormValues {
  firstName: string;
  lastName: string;
  phone: string;
  mfaWay: MfaWay;
  phoneVerifyCode: string;
  avatarFile: File;
  phoneVerifyCodeId: number,
}


const ProfileCreateBody: FC = () => {
  const user: UserResponseDto | undefined  = useSelector(getUserProfile)

  const [avatarFile, setAvatarFile] = useState<File | undefined>()
  
  const save = useSimpleSaveAction()
  
  const finalSave = useCallback(function(values: Partial<ProfileFormValues>, options: MutationCallbacks = {}) {
    save({ ...values, avatarFile: avatarFile }, options)
  }, [avatarFile, save])

  return (
    <Grid container spacing={3} >
      <Grid item lg={4} md={6} xl={3} xs={12} >
        <ProfileAvatar 
          prevAvatarUrl={user?.avatarUrl}
          username={user?.username}
          setAvatarFile={setAvatarFile}
        />
      </Grid>
      <Grid item lg={8} md={6} xl={9} xs={12} >
        <ProfileCreateForm 
          save={finalSave}
          user={user}
        />
      </Grid>
    </Grid>
  )
}
